"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  0%{\n    transform:translateY(0px)\n  }\n  28%{\n    transform:translateY(-5px)\n  }\n  44%{\n    transform:translateY(0px)\n }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var typing = (0, _react.keyframes)(_templateObject());

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;&::before,&::after{content:'';}span,&::before,&::after{display:inline-block;background-color:", theme.color.monochrome.superDark, ";width:5px;height:5px;border-radius:50%;margin:0 1px;animation:", typing, " 1.5s infinite ease-in-out;}&:before{animation-delay:0.2s;}span{animation-delay:0.3s;}&:after{animation-delay:0.4s;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=TypingIndicator.styles.js.map